// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1uYzb","title":"BackImages_title__39523","images":"BackImages_images__2POGl"};